import React from 'react';

import droneAirCraft from '../../../main/assets/images/droneSoccer/drone-soccer-aircraft.webp';

export const DroneSoccerAircraft = () => {
  return (
    <section className="soccer-aircraft-section">
      <div className="soccer-aircraft-text-section">
        <div className="soccer-aircraft-titles">
          <h2 className="soccer-aircraft-subtitle">ROBUST AND RELIABLE</h2>
          <h3 className="soccer-aircraft-title">DRONE SOCCER AIRCRAFT</h3>{' '}
        </div>
        <p className="soccer-aircraft-description">
          Built for full-contact action, its unique design ensures consistent
          performance and durability. Classified under FAI’s{' '}
          <span style={{ whiteSpace: 'nowrap' }}>F9A-B</span> Subclass and
          proudly made in the EU.
        </p>
      </div>
      <div className="soccer-aircraft-image-container">
        <img
          src={droneAirCraft}
          alt="Drone Soccer Aircraft"
          className="soccer-aircraft-image"
        />
      </div>
    </section>
  );
};
